import { FeatureName, ServiceName } from '@wix/thunderbolt-symbols'

export const getServicesToLoad = (featureNames: Array<FeatureName>): Array<ServiceName> =>
	featureNames.filter((featureName: FeatureName) => isService(featureName)) as Array<ServiceName>

export const isService = (featureName: string) => featureName.endsWith('Service')
